import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { Edit } from "@components/modules/invoices/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationProformaInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/proforma-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Edit invoice`}
    navigation={<NavigationProformaInvoice invoiceId={id} />}
  >
    <Edit.Proforma id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/proforma-invoices/edit")({
  component: RouteComponent,
});
